  
import { useField } from 'formik';
import { Form, Label } from 'semantic-ui-react';
import { normalizePhone } from '../util/util';

interface Props {
    placeholder: string;
    name: string;
    type?: string;
    label?: string;
    tabIndex?: number;
}

export default function MyPhoneInput(props: Props) {
    const [field, meta, helpers] = useField(props.name); 
    const { setValue } = helpers;

    return (
        <Form.Field error={meta.touched && !!meta.error}  >
            <label>{props.label}</label>
            <Label basic className='phone-country-label'>1 (US)</Label>
            <input className='phone-input floatRight' {...field} {...props} 
                value={field.value} 
                width='90%'
                onChange={(e) => {
                    var phone = normalizePhone(e.currentTarget.value);
                    setValue(phone); // phone formatter
                }}
            />
            {meta.touched && meta.error ? (
                <Label basic color='red' className='phone-error'>{meta.error}</Label>
            ) : null}
        </Form.Field>
    )
}